module.exports = __webpack_public_path__ + "static/media/ImgMBTI_SPTC.1844211e.png";